import {
  AI_CHAT_DISCOVERY_VARIANT,
} from '../constants'
import { getAiChatDiscoveryEffectiveVariant, isAiChatDiscoveryVariantResolved } from '../utils'
import { useAiChatDiscoveryVariant } from './use_ai_chat_discovery_variant'

const RIGHT_RAIL_DISCOVERY_VARIANTS = new Set([
  AI_CHAT_DISCOVERY_VARIANT.BUTTON_ONLY,
  AI_CHAT_DISCOVERY_VARIANT.TOP_BUTTON,
])

/**
 * Right-rail Ask Callie pane: `button_test_d` (FAB) and `button_test_top` (app bar).
 * Only mount/call from subtrees where {@link useAiChatDiscoveryMiEligible} is already true.
 */
export const useAiChatRightRailVariantAllowed = () => {
  const variant = useAiChatDiscoveryVariant(false)

  if (!isAiChatDiscoveryVariantResolved(variant)) {
    return false
  }

  const effectiveVariant = getAiChatDiscoveryEffectiveVariant(variant)
  return RIGHT_RAIL_DISCOVERY_VARIANTS.has(effectiveVariant)
}
